import { BaseLayout } from '@/components/Layout';
import { Providers } from '@/components/Providers';
import { t } from '@lingui/macro';
import MiloMap from '@milo/react/src/components/MiloMap';
import { GetStaticProps } from 'next';

export default function Map() {
  return (
    <Providers>
      <BaseLayout showBanner={false} showFooter={false}>
        <div style={{ height: 'calc(100vh - 82px)' }}>
          <MiloMap />
        </div>
      </BaseLayout>
    </Providers>
  );
}

export const getStaticProps: GetStaticProps = async () => {
  return {
    props: {
      seo: {
        title: t`Carte interactive`,
        description: t`Utilisez la carte M ta région interactive pour découvrir les meilleures expériences autour de vous.`,
      },
    },
  };
};
